import { Label } from "@xola/ui-kit";
import { FormikErrors } from "formik";
import React from "react";
import { TermsTemplate, TermsTemplateFee } from "types";
import { TermsTemplatePurchaseRuleInput } from "./TermsTemplatePurchaseRuleInput";

interface BasicTermsFormProps {
    values: TermsTemplate;
    errors?: FormikErrors<TermsTemplate>;
    setFieldValue: (key: string, value: TermsTemplateFee) => void;
}

export const BasicTermsForm = ({ values, errors, setFieldValue }: BasicTermsFormProps) => {
    return (
        <>
            <div className="flex space-x-10 py-12">
                <div className="w-1/4">
                    <h3>Discount</h3>
                    <p className="text-gray-darker">
                        Determine the discount the customer will receive when this Partner is associated to a
                        reservation
                    </p>
                </div>
                <div className="w-1/2 pl-8">
                    <div data-testid="edit-terms-template-discount">
                        <Label>Discount</Label>

                        <TermsTemplatePurchaseRuleInput
                            value={values.discount}
                            field="discount"
                            errors={errors?.discount}
                            onChange={(value) => setFieldValue("discount", value)}
                        />
                    </div>
                </div>
            </div>

            <div className="flex space-x-10 py-12">
                <div className="w-1/4">
                    <h3>Commissions</h3>
                    <p className="text-gray-darker">
                        Determine the commission the Partner will receive when they are associated to a reservation
                    </p>
                </div>
                <div className="w-1/2 pl-8">
                    <div data-testid="edit-terms-template-commission">
                        <Label>Commission</Label>

                        <TermsTemplatePurchaseRuleInput
                            value={values.commission}
                            field="commission"
                            errors={errors?.commission}
                            onChange={(value) => setFieldValue("commission", value)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
